module.exports = __webpack_public_path__ + "static/media/listaQuickStartGuide.8abf28d0.pdf";